import styled from 'styled-components'

import { WhiteBlock } from 'components/Layout'
import theme from 'theme_'
import { Secondary } from 'components/Typography'
import { TextField } from 'components/Fields'
import CommonButton from 'components/Button/CommonButton'

const BOTTOM_PANEL_HEIGHT = '40px'

export const NetworkWizardContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: calc(${BOTTOM_PANEL_HEIGHT} + ${theme.spacing.md});
`

export const NetworkWizardWhiteBlock = styled(WhiteBlock)`
  gap: 16px;
  align-items: center;
  width: 100%;
  padding: ${theme.spacing.md};
`

export const NetworkWizardJobNameBlock = styled(NetworkWizardWhiteBlock)`
  padding: ${theme.spacing.base} ${theme.spacing.md} 0 ${theme.spacing.md};
`

export const NetworkWizardErrorWrapper = styled.span`
  color: ${theme.colors.error};
`

export const NetworkWizardTextField = styled(TextField)`
  border: 1px solid ${theme.colors.pelicanGrey};
`

export const NetworkWizardTitle = styled.h1`
  margin: 0;
  font-size: 18px;
  line-height: 32px;
  @media ${theme.devices.tablet} {
    font-size: 28px;
    line-height: 40px;
  }
`

export const NetworkWizardSecondaryTitle = styled(Secondary)`
  color: ${theme.colors.moreGrey};
`

export const NetworkWizardWhiteBlockHeader = styled.div`
  width: 100%;
`

export const NetworkWizardWhiteBlockBody = styled.div`
  width: 100%;
  max-width: 480px;
`

export const NetworkWizardBottomPanel = styled.div`
  display: flex;
  justify-content: center;
  gap: ${theme.spacing.base};
  min-height: ${BOTTOM_PANEL_HEIGHT};

  @media ${theme.devices.tablet} {
    justify-content: flex-end;
  }
`

export const NetworkWizardCancelButton = styled(CommonButton)`
  background: transparent;
  min-width: 160px;
  width: 100%;
  height: 40px;
  @media ${theme.devices.tablet} {
    width: auto;
  }
`

export const NetworkWizardSubmitButton = styled(CommonButton)`
  min-width: 160px;
  width: 100%;
  height: 40px;
  @media ${theme.devices.tablet} {
    width: auto;
  }
`
